import React, { useState } from 'react';

import If from 'gp-if';
import './styles.scss';

const Toggle = ({ id, value, item, disabled = false, onChange, onlyOneLabel = undefined }) => {
    const [switchValue, setSwitchValue] = useState(value);
    const handleSwitchChange = () => {
        const value = !switchValue;
        setSwitchValue(value);
        if (onChange) {
            if (item) {
                onChange(item, value);
            } else {
                onChange(value);
            }
        }
    }

    return (
        <div className="custom-control custom-switch">
            <input type="checkbox" className="custom-control-input" id={'toggle' + id} checked={switchValue} onChange={handleSwitchChange} disabled={disabled} />
            <label className="custom-control-label" htmlFor={'toggle' + id}>
                <If test={!onlyOneLabel}>
                    <If test={switchValue}>
                        <span className="toggle-switch-label">Sim</span>
                    </If>
                    <If test={!switchValue}>
                        <span className="toggle-switch-label">Não</span>
                    </If>
                </If>
                <If test={onlyOneLabel}>
                    <span className="toggle-switch-label">{onlyOneLabel}</span>
                </If>
            </label>
        </div>

    )
}

export default Toggle;